import React, { useState, useEffect } from 'react'
import { Box, Button, Typography } from '@mui/material'

const ResendOTPButton = ({ createdAt, seconds, waitingText, actionText, onResend }) => {
  const [timer, setTimer] = useState(0)
  const [isDisabled, setIsDisabled] = useState(true)
  const [modal, setModal] = useState(false)

  useEffect(() => {
    const now = Math.floor(Date.now() / 1000)
    const elapsedTime = now - Math.floor(new Date(createdAt).getTime() / 1000)
    const remainingTime = Math.max(seconds - elapsedTime, 0)

    setTimer(remainingTime)
    setIsDisabled(remainingTime > 0)

    const interval = setInterval(() => {
      setTimer(prev => {
        if (prev <= 1) {
          clearInterval(interval)
          setIsDisabled(false)
          return 0
        }

        // 🔥 Verifica se o tempo está entre 15 e 0 segundos, atualizando o modal dinamicamente
        if (prev <= 15 && prev > 0) {
          setModal(true)
        } else {
          setModal(false)
        }

        return prev - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [createdAt, seconds])

  const handleClick = () => {
    if (!isDisabled) {
      setIsDisabled(true)
      setTimer(seconds)
      onResend()
      setModal(false) // 🔥 Fecha o modal ao reenviar código
    }
  }

  return (
    <>
      <Button variant='text' onClick={handleClick} disabled={isDisabled}>
        {isDisabled
          ? waitingText.replace(
              '{time}',
              `${Math.floor(timer / 60)}:${String(timer % 60).padStart(2, '0')}`,
            )
          : actionText}
      </Button>
      {modal && (
        <Box sx={styl.containAlert}>
          <Typography variant='body2' sx={styl.title}>
            O CÓDIGO NÃO CHEGOU?
          </Typography>
          <Typography variant='body2' sx={styl.subTitle}>
            Confira sua caixa de spam, ele pode ter ido para lá.
          </Typography>
        </Box>
      )}
    </>
  )
}

export default ResendOTPButton

const styl = {
  containAlert: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    height: 'auto',
    width: '100%',
    padding: '10px',
    marginTop: '10px',
    borderRadius: '7px',
    backgroundColor: 'black',
  },
  title: {
    color: 'white',
    fontWeight: 'bold',
  },
  subTitle: {
    color: 'white',
    fontWeight: 'normal',
  },
}
